import React, { PureComponent } from 'react'

import {
    BrowserRouter as Router,
    Route,
    Switch,
} from 'react-router-dom'

import CreateEdit from './CreateEdit'
import Search from './Search'
import KpiStore from './KpiStore'

import './style.scss'

class KpiCreator extends PureComponent {
    constructor(props) {
        super(props)
        this.kpiStore = new KpiStore(props.store)

        props.store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'kpis',
                url: '/intranet/kpicreator',
                title: 'Kpis',
            },
        ]
    }

    render() {
        const { store } = this.props
        const appHistory = this.props.history
        return (
            <div id="kpiCreator">
                <Router>
                    <Switch>
                        <Route
                            path="/intranet/kpicreator/0"
                            render={({ match, history }) => (
                                <CreateEdit
                                    kpiStore={this.kpiStore}
                                    store={store}
                                    kpiId={0}
                                    history={history}
                                    match={match}
                                />
                            )}
                        />
                        <Route
                            path="/intranet/kpicreator/:kpiId"
                            render={({ match, history }) => (
                                <CreateEdit
                                    kpiStore={this.kpiStore}
                                    store={store}
                                    kpiId={match.params.kpiId}
                                    history={history}
                                    match={match}
                                />
                            )}
                        />
                        <Route
                            path="/intranet/kpicreator"
                            render={({ match, history }) => (
                                <Search
                                    kpiStore={this.kpiStore}
                                    appHistory={appHistory}
                                    store={store}
                                    history={history}
                                    match={match}
                                />
                            )}
                        />
                        <Route
                            render={() => (
                                <div>not found kpi</div>
                            )}
                        />
                    </Switch>
                </Router>
            </div>
        )
    }
}

export default KpiCreator
